import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from './app/app.config';
import { buildKeycloakInitOptions } from './app/init/keycloakConfiguration';
import { requestTokensFromPeers } from './app/init/cross-tab-auth';
import { AppComponent } from './app/app.component';

// Before bootstrapping, ask any already-open tab for its tokens. If one answers,
// we initialize Keycloak with those tokens instead of redirecting to log in —
// which keeps every tab authenticated without creating a fresh login-attempt row.
// If no tab answers (this is the first/only tab), we fall back to a normal login.
requestTokensFromPeers()
  .then(inheritedTokens => {
    const initOptions = buildKeycloakInitOptions(inheritedTokens);
    return bootstrapApplication(AppComponent, createAppConfig(initOptions));
  })
  .catch(err => console.error(err));
